import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "24px",
    backgroundColor: "#ffffff",
    minHeight: "100vh",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
  },
  pageTitle: {
    fontSize: "20px !important",
    fontWeight: "700 !important",
    color: "#1e293b",
    fontFamily: "'Inter', sans-serif !important",
  },
  breadcrumb: {
    fontSize: "14px !important",
    color: "#64748b",
    fontFamily: "'Inter', sans-serif !important",
    "& span": {
      fontWeight: "600",
      color: "#1e293b",
    },
  },
  actionRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    flexWrap: "wrap",
    gap: "16px",
  },
  searchWrapper: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #e2e8f0",
    borderRadius: "100px",
    padding: "6px 16px",
    width: "320px",
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    "&:focus-within": {
      borderColor: "#94a3b8",
    },
  },
  searchInput: {
    border: "none",
    outline: "none",
    width: "100%",
    marginLeft: "8px",
    fontSize: "14px",
    color: "#334155",
    "&::placeholder": {
      color: "#94a3b8",
    },
  },
  searchIcon: {
    color: "#94a3b8",
    fontSize: "20px",
  },
  exportGroup: {
    display: "flex",
    backgroundColor: "#1e1e1e",
    borderRadius: "6px",
    padding: "2px",
    overflow: "hidden",
  },

  paginationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 24px",
    borderTop: "1px solid #ECEEF2",
    background: "#fff",
  },

  paginationText: {
    fontSize: 14,
    color: "#5F6470",
    fontWeight: 500,
  },

  paginationControls: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },

  pageButton: {
    minWidth: 34,
    width: 34,
    height: 34,
    borderRadius: 10,
    color: "#2C3345",
    fontWeight: 500,
    background: "transparent",
    "&:hover": {
      background: "#F5F5F5",
    },
  },

  pageButtonActive: {
    minWidth: 34,
    width: 34,
    height: 34,
    borderRadius: 10,
    background: "#1F1F1F !important",
    color: "#fff !important",
    fontWeight: 600,
    "&:hover": {
      background: "#1F1F1F !important",
    },
  },

  pageDots: {
    fontSize: 18,
    color: "#8A9099",
    padding: "0 6px",
  },

  pageArrow: {
    fontSize: 22,
    color: "#5F6470",
    cursor: "pointer",
    "&.disabled": {
      opacity: 0.35,
      pointerEvents: "none",
    },
  },
  exportButton: {
    color: "#ffffff !important",
    fontSize: "12px !important",
    textTransform: "none !important",
    padding: "6px 16px !important",
    minWidth: "auto !important",
    fontWeight: "500 !important",
    borderRight: "1px solid #334155 !important",
    borderRadius: "0px !important",
    "&:last-child": {
      borderRight: "none !important",
    },
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1) !important",
    },
  },
  tableWrapper: {
    width: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    overflow: "hidden",
  },
  tableHeaderRow: {
    backgroundColor: "#f8fafc",
    display: "flex",
    padding: "16px 24px",
    borderBottom: "1px solid #f1f5f9",
  },
  tableHeaderCell: {
    fontSize: "12px !important",
    fontWeight: "600 !important",
    color: "#475569 !important",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    fontFamily: "'Inter', sans-serif !important",
  },
  tableRow: {
    display: "flex",
    padding: "20px 24px",
    alignItems: "center",
    borderBottom: "1px solid #f1f5f9",
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: "#f8fafc",
    },
  },
  tableCell: {
    fontSize: "14px !important",
    color: "#334155 !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  boldText: {
    fontWeight: "700 !important",
    color: "#0f172a !important",
  },
  statusBadgeActive: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 12px",
    borderRadius: "100px",
    fontSize: "12px",
    fontWeight: "600",
    backgroundColor: "#f0fdf4",
    color: "#16a34a",
    border: "1px solid #bbf7d0",
    gap: "6px",
    "&::before": {
      content: "''",
      display: "block",
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      backgroundColor: "#16a34a",
    },
  },
  statusBadgeInactive: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 12px",
    borderRadius: "100px",
    fontSize: "12px",
    fontWeight: "600",
    backgroundColor: "#fef2f2",
    color: "#dc2626",
    border: "1px solid #fecaca",
    gap: "6px",
    "&::before": {
      content: "''",
      display: "block",
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      backgroundColor: "#dc2626",
    },
  },
  actionButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    color: "#64748b",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    marginRight: "20px",
    transition: "color 0.2s",
    "&:hover": {
      color: "#1e293b",
    },
  },
  actionDeleteButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    color: "#64748b",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "color 0.2s",
    "&:hover": {
      color: "#dc2626",
    },
  },
  // Add Customer Care Button (Floating or Top bar)
  addCustomerButton: {
    backgroundColor: "#1e1e1e !important",
    color: "#ffffff !important",
    borderRadius: "8px !important",
    padding: "10px 20px !important",
    textTransform: "none !important",
    fontWeight: "600 !important",
    fontFamily: "'Inter', sans-serif !important",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1) !important",
    "&:hover": {
      backgroundColor: "#2e2e2e !important",
    },
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
    backgroundColor: "#ffffff",
    borderTop: "1px solid #f1f5f9",
    fontFamily: "'Inter', sans-serif",
  },
  paginationText: {
    fontSize: "14px",
    color: "#64748b",
    fontWeight: "500",
  },
  paginationControls: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  pageButton: {
    minWidth: "32px !important",
    height: "32px",
    padding: "0 !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
    color: "#475569 !important",
    textTransform: "none !important",
    borderRadius: "8px !important",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#f1f5f9 !important",
    },
  },
  pageButtonActive: {
    minWidth: "32px !important",
    height: "32px",
    padding: "0 !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
    color: "#ffffff !important",
    backgroundColor: "#1e1e1e !important",
    borderRadius: "8px !important",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#2e2e2e !important",
    },
  },
  pageDots: {
    padding: "0 4px",
    color: "#94a3b8",
    fontSize: "14px",
    fontWeight: "500",
    userSelect: "none",
  },
  pageArrow: {
    color: "#64748b",
    cursor: "pointer",
    transition: "color 0.2s",
    "&:hover": {
      color: "#0f172a",
    },
    "&.disabled": {
      color: "#cbd5e1",
      cursor: "not-allowed",
      pointerEvents: "none",
    },
  },
}));

export default useStyles;
